// extracted by mini-css-extract-plugin
module.exports = {"container":"MyMenu_container__nUXFP","line":"MyMenu_line__309U2","line1":"MyMenu_line1__i6Ko4","line2":"MyMenu_line2__ZJ08_","line3":"MyMenu_line3__1Chvp"};